/**
 * Registry of partner documentation, grouped into sidebar sections.
 *
 * Each group is a folder under `public/docs/`; each page's `slug` is its path
 * (folder/name) and maps to the markdown file `public/docs/<slug>.md`.
 *
 * Adding a page = drop `public/docs/<group>/<name>.md` and add a page entry here.
 * Adding a section = add a new group.
 */
export interface DocPage {
  /** Path under `docs/` — used both as the URL and the markdown file (`<slug>.md`). */
  slug: string;
  /** Sidebar label. */
  title: string;
  /** Optional badge next to the label (e.g. "Beta"). */
  tag?: string;
}

export interface DocGroup {
  /** Section header in the sidebar. */
  title: string;
  /** Optional badge next to the group header. */
  tag?: string;
  pages: DocPage[];
}

export const DOC_GROUPS: DocGroup[] = [
  {
    title: 'Webhooks',
    tag: 'Beta',
    pages: [
      { slug: 'webhooks/overview', title: 'Overview' },
      { slug: 'webhooks/events', title: 'Events & Payloads' },
      { slug: 'webhooks/authentication', title: 'Authentication' },
      { slug: 'webhooks/delivery', title: 'Delivery & Retries' },
      { slug: 'webhooks/managing', title: 'Managing in the Portal' },
    ],
  },
];

/** All pages flattened, in sidebar order. */
export const DOC_PAGES: DocPage[] = DOC_GROUPS.flatMap((group) => group.pages);
